<script setup>
// Embla.
import emblaCarouselVue from 'embla-carousel-vue';
import Fade from 'embla-carousel-fade';
// Vue.
import { onMounted, ref, watch } from 'vue';

// Props.
const props = defineProps({
  tabNames: {
    type: Array,
    required: true,
    default: () => [],
  },
});

// Data.
const [emblaElement, emblaCarousel] = emblaCarouselVue(
  {
    containScroll: false,
    draggable: false,
    watchDrag: false,
  },
  [Fade()],
);

// The tabs at the top of the section.
const [thumbsElement, thumbsCarousel] = emblaCarouselVue();
const activeTabIndex = ref(0);

// Mounted.
onMounted(() => {
  // React to select events on both carousels.
  [thumbsCarousel, emblaCarousel].forEach((carousel) => {
    carousel.value.on('select', () => {
      activeTabIndex.value = carousel.value.selectedScrollSnap();
    });
  });
});

// Watchers.
watch(activeTabIndex, (value, oldValue) => {
  if (oldValue !== value) {
    [thumbsCarousel, emblaCarousel].forEach((carousel) => {
      // Do the scroll only if the carousel is not already at the selected index.
      if (carousel.value.selectedScrollSnap() !== value) {
        carousel.value.scrollTo(value);
      }
    });
  }
});
</script>

<template>
  <div class="target-numbers embla">
    <div class="embla-thumbs">
      <div ref="thumbsElement" class="embla-thumbs__viewport">
        <div class="embla-thumbs__container">
          <div
            v-for="(tab, index) in tabNames"
            class="embla-thumbs__slide"
            :class="{
              'embla-thumbs__slide--active': activeTabIndex === index,
            }">
            <button
              class="target-numbers__thumb"
              @click="activeTabIndex = index">
              <strong>{{ tab }}</strong>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div ref="emblaElement" class="embla__viewport">
      <div class="embla__container">
        <!-- Slides are passed in from Twig. -->
        <slot />
      </div>
    </div>
  </div>
</template>
